<template>
	<div>
<!-- DISCO LOGO ------------------------------------------------------- -->
		<transition
			appear
			enter-active-class="animated zoomIn"
			leave-active-class="animated pulse"  
			mode="out-in">
			<div class="container" id="noPadding">
				<div v-show="discoLogo" id="discoTitle">
					<div class="col-xs-12 text-center" id="noPadding">	
						<svg id="svgTitle" viewBox="0 0 1200 200">
						  <symbol id="s-text">
						    <text text-anchor="middle" x="600" y="50" dy=".65em">
						    {{FutureFit}}
						    </text>
						  </symbol>
						  <use class="text" xlink:href="#s-text"></use>
						  <use class="text" xlink:href="#s-text"></use>
						  <use class="text" xlink:href="#s-text"></use>
						  <use class="text" xlink:href="#s-text"></use>
						  <use class="text" xlink:href="#s-text"></use>
						</svg>
					</div>
				</div>
			</div>
		</transition>
<!-- HELP SECTION  ---------------------------------------------------- -->
	<transition
				appear
				enter-active-class="animated zoomIn"
				leave-active-class="animated fadeOut"  
				mode="out-in">

		<div class="container-fluid" v-show="showHelp" id="noPadding">

			

				<p id="mattMcCorkle"  style="color: red">
  					<strong> Created by: </strong>
  					<br> 
  					<a href="https://www.mattmccorkle.com" target="_blank" style="color: red"> 
  					<u>Matt McCorkle</u> </a>
  					@
  					<a href="https://www.newinc.org" target="_blank" style="color: red">
  					<u>NEW INC</u></a></p>
  				<br>
  				<p id="mattMcCorkle"  style="color: red">
  					<strong> Music by: </strong>
  					<br>
  					"The Skeleton Rag" 
					<br>
  					from 
  					<a href="http://www.samreidermusic.com/" target="_blank" style="color: red"><u>
  					Sam Reider's</u></a>
  					<br>
  					upcoming recording 
  					<br>
  					<strong> "Too Hot To Sleep" </strong>
				</p>
				<br>
				<br>
				<div id="shoutOutPullDown">
				<!-- 	<p id="shoutOuts"> Special thanks to Amelia Pisapia for her advice and inspiration. </p> -->
						<!-- <p id="shoutOuts"><strong> Shout out to these awesome APIs: </strong></p> -->
						<p id="shoutOuts"> <a href="https://tonejs.github.io/" target="_blank" style="color: red">Special thanks to <u>Tone.js</u> by Yotam Mann</a></p>
						</p>
				</div>


				<p id="mattMcCorkle" style="color: red"> Stay in touch for new project releases! 
				<br>
						</p>
						<!-- <link href="//cdn-images.mailchimp.com/embedcode/horizontal-slim-10_7.css" rel="stylesheet" type="text/css"> -->
						<div id="mc_embed_signup">
						<form action="https://space.us12.list-manage.com/subscribe/post?u=cc407290614bbaa2daa32fe9e&amp;id=219d3ce36c" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
						    <div id="mc_embed_signup_scroll">
							
							<input type="email" 
								   value="" 
								   name="EMAIL" 
								   class="email" 
								   id="mce-EMAIL" 
								   placeholder="email address" required>
						    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
						    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_cc407290614bbaa2daa32fe9e_219d3ce36c" tabindex="-1" value=""></div>
							    	
							    	<input 	type="submit" 
							    			value="Subscribe!" 
							    			name="subscribe" 
							    			id="mc-embedded-subscribe" 
							    			class="btn btn-info">
						    </div>
						</form>
						</div>
				<br>
  				
				<br>
					<button
							id="helpBtnHome"
							class="btn btn-blackwhiteneg"
							@click="goToHome"
						>
						<strong> Now Take Me Back! </strong>
					</button>
					<br>
					<br>
					<!-- <p style="color:red"><i class="fa fa-copyright"></i> EqualSonics LLC </p>	 -->
		</div>
	</transition>
<!-- MAIN SECTION ----------------------------------------------------- -->
	<transition
				appear
				enter-active-class="animated zoomIn"
				leave-active-class="animated zoomOut"  
				mode="out-in">

		<div class="container-fluid" v-show="showSection" id="noPadding">

			<div class="col-xs-12 col-xs-offset-0" id="Section1PullUp">
			<!-- AMBIENCES -->
					<p id="Section1TitleText">
						<strong> {{LoadingText1}} </strong>
					</p>

				
							<div class="row">
								<div class="col-xs-6">
									<button 
										id="ambienceBtns"
										:class="ambience1Class"
										@click="ambience1Func"
										> <i :class="ambience1Icon" style="color:white"></i>
										Fierce Storm
										</button>
										<br>
										<br>
										<input 
											type="range"
											class="dangerRanger"
											v-model="ambience1Vol"
											:="ambienceMixing"
											max="5" min="-30" step="1"
											><br><span id="ambienceBadges" class="badge">Volume {{ambience1Vol}} dB</span>		
										</input>
							 	</div>	
									<button 
										id="ambienceBtns"
										:class="ambience2Class"
										@click="ambience2Func"
										> <i :class="ambience2Icon" style="color:white"></i>
										Graveyard
										</button>
										<br>
										<br>
										<input 
											type="range"
											class="dangerRanger"
											v-model="ambience2Vol"
											:="ambienceMixing"
											max="5" min="-20" step="1"
											><br><span id="ambienceBadges" class="badge">Volume {{ambience2Vol}} dB</span>			 				
										</input>
							</div>
									<br>
							<div class="row">
								<div class="col-xs-6">
									<button 
										id="ambienceBtns"
										:class="ambience3Class"
										@click="ambience3Func"
										> <i :class="ambience3Icon" style="color:white"></i>
										Sewer
										</button>
										<br>
										<br>
										<input 
											type="range"
											class="dangerRanger"
											v-model="ambience3Vol"
											:="ambienceMixing"
											max="5" min="-20" step="1"
											><br><span id="ambienceBadges" class="badge">Volume {{ambience3Vol}} dB</span>	
										</input>
								</div>
									<button 
										id="ambienceBtns"
										:class="ambience4Class"
										@click="ambience4Func"
										> <i :class="ambience4Icon" style="color:white"></i>
										Laboratory
										</button>
										<br>
										<br>
										<input 
											type="range"
											class="dangerRanger"
											v-model="ambience4Vol"
											:="ambienceMixing"
											max="5" min="-20" step="1"
											><br><span id="ambienceBadges" class="badge">Volume {{ambience4Vol}} dB</span>	
										</input>		
					</div>
				<br>
			<!-- MUSIC BUTTONS-->
				<p id="Section2BodyText">
				<strong> {{LoadingText3}} </strong>
				</p>
				<div class="row">
					<div class="col-xs-4">	
						<button 
							id="SFXBtnRepeat"
							:class="SFX1Class"
							:="musicVolume1"
							@click="SFX1Boolean = !SFX1Boolean"
							>
							Accordion
						</button>
						
						<br>
						<br>
					</div>
					<div class="col-xs-4">	
						<button 
							id="SFXBtnRepeat"
							:class="SFX2Class"
							:="musicVolume2"
							@click="SFX2Boolean = !SFX2Boolean"
							>
							Bass
						</button>
						
						<br>
						<br>
					</div>
					<div class="col-xs-4">	
						<button 
							id="SFXBtnRepeat"
							:class="SFX3Class"
							:="musicVolume3"
							@click="SFX3Boolean = !SFX3Boolean"
							>
							Saxophone
						</button>
						
						<br>
						<br>
					</div>
				</div>
				
				<div class="row">
					<div class="col-xs-4">			
						<button 
							id="SFXBtnRepeat"
							:class="SFX4Class"
							:="musicVolume4"
							@click="SFX4Boolean = !SFX4Boolean"
							>
							Mandolin
						</button>
						
					</div>
					<div class="col-xs-4">
						<button 
							id="SFXBtnRepeat"
							:class="SFX5Class"
							:="musicVolume5" 
							@click="SFX5Boolean = !SFX5Boolean"
							>
							Fiddle
						</button>
						
						<br>
					</div>
					<div class="col-xs-4">
						<button 
							id="SFXBtnRepeat"
							:class="SFX6Class"
							:="musicVolume6" 
							@click="SFX6Boolean = !SFX6Boolean"
							>
							Guitar
						</button>
						
						<br>
					</div>
				</div>

				<button 
						id="MusicNukeBtn"
						:class="destroyClass"
						:="audioMixing"
						@click="destroyFunc"
						><i :class="musicNukeIcon" v-bind:style="{'color': destroyIt ? stopColor : playColor }"></i>
						<strong>{{SkeletonDance}}</strong>
						<i :class="musicNukeIcon" v-bind:style="{'color': destroyIt ? stopColor : playColor }"></i>
				</button>

				<br>
				<br>
			<!-- MUSIC SLIDERS -->
				<div class="row">
					<div class="col-xs-4">	
						
							<input 
								id="SFXRepearSlider"
								type="range"
								class="warningRanger"
								v-model="SFX1MODEL"
								:="audioMixing"
								max="2" min=".1" step=".1"
								><br><span id="SFXRepeatBadge"  class="badge">Music Speed {{SFX1MODEL}}x </span>	
							</input>
						<br>
						<br>
					</div>
					<div class="col-xs-4">	
						
							<input 
								id="SFXRepearSlider"
								type="range"
								class="warningRanger"
								v-model="sfxChorus"
								:="audioMixing"
								max="100" min="0" step="1"
								><br><span id="SFXRepeatBadge"  class="badge">Music Chorus {{sfxChorus}}% </span>	
							</input>
						<br>
						<br>
					</div>
					<div class="col-xs-4">	
						
							<input 
								id="SFXRepearSlider"
								type="range"
								class="warningRanger"
								v-model="musicReverb"
								:="audioMixing"
								max="100" min="0" step="1"
								><br><span id="SFXRepeatBadge"  class="badge">Music Reverb {{musicReverb}}% </span>	
							</input>
						<br>
						<br>
					</div>
				</div>
				
				<div class="row">
					<div class="col-xs-4">			
						
							<input 
								id="SFXRepearSlider"
								type="range"
								class="warningRanger"
								v-model="musicVol"
								:="audioMixing"
								max="5" min="-20" step="1"
								><br><span id="SFXRepeatBadge"  class="badge">Music Volume {{musicVol}}dB </span>	
							</input>
						<br>
					</div>
					<div class="col-xs-4">
						
							<input 
								id="SFXRepearSlider"
								type="range"
								class="warningRanger"
								v-model="musicFilter"
								:="audioMixing"
								max="100" min="0" step="1"
								><br><span id="SFXRepeatBadge"  class="badge">Music Warp {{musicFilter}}% </span>	
							</input>
						<br>
					</div>
					<div class="col-xs-4">
						
							<input 
								id="SFXRepearSlider"
								type="range"
								class="warningRanger"
								v-model="musicDestroy"
								:="audioMixing"
								max="100" min="0" step="1"
								><br><span id="SFXRepeatBadge" class="badge">Music Destroy {{musicDestroy}}%</span>	
							</input>
					</div>
				</div>	
			<br>
			<br>
									<div class="col-xs-12" id="Evilizor">
										<input 
											id="evilSlider"
											type="range"
											class="dangerRanger2"
											v-model="masterDistort"
											:="audioMixing"
											max="100" min="0" step="1"
											><br><span id="audioBadge" class="badge" style="background-color: red"> <span style="color: white"> Sound Effect EVIL-IZOR {{masterDistort}}% </span> </span>	
										</input>
									</div>	
													
			<!-- SFX -->
				<p id="Section1BodyText">
					<strong> {{LoadingText2}} </strong>
				</p>
					
					<button 
						id="SFXBtn"
						:class="SFX11Class"
						@click="SFX11"
						>
					 	Laugh
					</button>

					<button 
						id="SFXBtn"
						:class="SFX21Class"
						@click="SFX21"
						>
						Ghost Whisper
					</button>

					<button 
						id="SFXBtn"
						:class="SFX25Class"
						@click="SFX25"
						>
						Screams
					</button>

					<button 
						id="SFXBtn"
						:class="SFX22Class"
						@click="SFX22"
						>
						Insect Swarm
					</button>


					<button 
						id="SFXBtn"
						:class="SFX9Class"
						@click="SFX9"
						>
						Gouge
					</button>

					<button 
						id="SFXBtn"
						:class="SFX7Class"
						@click="SFX7"
						>
						Zombie Growl
					</button>
					
					<button 
						id="SFXBtn"
						:class="SFX8Class"
						@click="SFX8"
						>
						Angry Zombie
					</button>
					
					<button 
						id="SFXBtn"
						:class="SFX12Class"
						@click="SFX12"
						>
						Angry Beast
					</button>
					
					<button 
						id="SFXBtn"
						:class="SFX10Class"
						@click="SFX10"
						>
						Crow
					</button>

					<button 
						id="SFXBtn"
						:class="SFX13Class"
						@click="SFX13"
						>
						Chainsaw
					</button>
					
					<button 
						id="SFXBtn"
						:class="SFX14Class"
						@click="SFX14"
						>
						Knife
					</button>
					
					<button 
						id="SFXBtn"
						:class="SFX15Class"
						@click="SFX15"
						>
						Medical Saw
					</button>
					
					<button 
						id="SFXBtn"
						:class="SFX16Class"
						@click="SFX16"
						>
						Torch
					</button>

					<button 
						id="SFXBtn"
						:class="SFX23Class"
						@click="SFX23"
						>
						Contraption
					</button>

					<button 
						id="SFXBtn"
						:class="SFX17Class"
						@click="SFX17"
						>
						Wormhole
					</button>

					<button 
						id="SFXBtn"
						:class="SFX18Class"
						@click="SFX18"
						>
						Drama
					</button>

					<button 
						id="SFXBtn"
						:class="SFX19Class"
						@click="SFX19"
						>
						Interdimensional
					</button>

					<button 
						id="SFXBtn"
						:class="SFX20Class"
						@click="SFX20"
						>
						Saturn
					</button>

					
					<button 
						id="SFXBtn"
						:class="SFX24Class"
						@click="SFX24"
						>
						Bio Suit
					</button>

					

					<button 
						id="SFXBtn"
						:class="SFX26Class"
						@click="SFX26"
						>
						Needs A Sub
					</button>
					<br>
					<br>
					<div class="col-xs-12" id="Evilizor">
										<input 
											id="evilSlider"
											type="range"
											class="dangerRanger2"
											v-model="sfxVol"
											:="audioMixing"
											max="5" min="-5" step="1"
											><br><span id="audioBadge" class="badge" style="background-color: red"> <span style="color: white"> Horrible Sounds Volume {{sfxVol}}dB </span> </span>	
										</input>
									</div>		

					<!-- <div class="col-xs-12" id="Evilizor">
						<input 
							id="evilSlider"
							type="range"
							class="dangerRanger2"
							v-model="SFXverb"
							:="audioMixing"
							max="0" min="-70" step="1"
							><br><span id="audioBadge" class="badge" style="background-color: red"> <span style="color: white"> SFX Reverb {{SFXverb}}% </span> </span>	
						</input>		
					</div> -->


					<!-- <button 
						id="SFXBtn"
						:class="SFX27Class"
						@click="SFX27"
						>
						Saturn
					</button>

					<button 
						id="SFXBtn"
						:class="SFX28Class"
						@click="SFX28"
						>
						Saturn
					</button> -->
				
				<!-- <button
					id="showAudio"
					:class="audioControl"
					@click="showAudio = !showAudio">
					Audio Control		
				</button> -->
				
			</div>
			<button
						id="helpBtn"
						class="btn btn-blackwhiteneg"
						:="audioMixing"
						@click="goToHelp"
					>
					<strong> Why Make Such A Thing? </strong>
					</button>	

					<!-- <p style="font-size: 22px; color:#FFB817">
						<strong> Share the scare:  </strong>
						<br>
						
						<a href="https://www.facebook.com/sharer/sharer.php?u=https%3A//www.halloweensoundboard.com/" style="color: #FFB817" target="_blank"><i class="fa fa-facebook-official fa-2x"></i></a>
						
						<a href="https://twitter.com/home?status=Create%20your%20own%20spooky%20soundscapes%20with%20eerie%20ambiances,%20frightening%20sounds%20and%20mysterious%20music.%20halloweensoundboard.com" style="color: #FFB817" target="_blank"><i class="fa fa-twitter-square fa-2x"></i></a>

						<a href="http://reddit.com/submit?url=www.halloweensoundboard.com&title=The%20Halloween%20Soundboard" style="color: #FFB817" target="_blank"><i class="fa fa-reddit-square fa-2x"></i></a>

						</p> -->
					<br>
					<br>
		</div>			
	</transition>
	</div>
</template>
<script>
import StartAudioContext from '../../node_modules/startaudiocontext/StartAudioContext.js'
import Tone from '../../node_modules/Tone/build/Tone.min.js'

import { eventBus } from '../main.js';

	export default {
data: () => ({
			stopColor:          'white',
			playColor:          'yellow',
			SkeletonDance:      'Summon The Music Demon',
	//SHOW AND HIDE	
			WelcomeText:        true,	
			discoLogo: 			true,
			Subtitle:           true,
		//V-SHOWS
			showNavBar:         false,
			showSection: 		true,
			showHelp:         	false,
		//CONTROLS
			section1control: 	false,
			section2control:    false,
			section3control:    false,
			FutureFit:          'Loading...',
			LoadingText1:        'Loading, Please Wait A Moment',
			LoadingText2:        'Loading, Please Wait A Moment',
			LoadingText3:        'Loading, Please Wait A Moment',
			textTiming: 		500,
			startStopTrigger:   false,
			// playColor: 			 "#5CE826",	
			// stopColor:           "#E84B46",
		//AMBIENCE BOOLEANS
			ambience1Boolean:   false,
			ambience2Boolean:   false,
			ambience3Boolean:   false,
			ambience4Boolean:   false,
			ambience1Disable:   true,
			ambience2Disable:   true,
			ambience3Disable:   true,
			ambience4Disable:   true,
		//AMBIENCE DATA
			ambience1Vol:               -10,
			ambience2Vol:               -5,
			ambience3Vol:               -5,
			ambience4Vol:               -5,
			ambience1Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"loopStart"  : 0.025,
										"loopEnd"  : 21.061,
			  							"volume": 6,
			  							}).toMaster(),
			ambience2Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"loopStart"  : 0.025,
										"loopEnd"  : 16.601,
			  							"volume": 6,
			  							}).toMaster(),
			ambience3Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"loopStart"  : 0.045,
										"loopEnd"  : 26.76,
			  							"volume": 6,
			  							}).toMaster(),
			ambience4Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"loopStart"  : 0.025,
										"loopEnd"  : 25.513,
			  							"volume": 6,
			  							}).toMaster(),
		//SOUND EFFECTS BOOLEANS
			SFX1Boolean:        true,
			SFX2Boolean:        true,
			SFX3Boolean:        true,
			SFX4Boolean:        true,
			SFX5Boolean:        true,
			SFX6Boolean:        true,
			SFX7Boolean:        false,
			SFX8Boolean:        false,
			SFX9Boolean:        false,
			SFX10Boolean:        false,
			SFX11Boolean:        false,
			SFX12Boolean:        false,
			SFX13Boolean:        false,
			SFX14Boolean:        false,
			SFX15Boolean:        false,
			SFX16Boolean:        false,
			SFX17Boolean:        false,
			SFX18Boolean:        false,
			SFX19Boolean:        false,
			SFX20Boolean:        false,
			SFX21Boolean:        false,
			SFX22Boolean:        false,
			SFX23Boolean:        false,
			SFX24Boolean:        false,
			SFX25Boolean:        false,
			SFX26Boolean:        false,
			SFX27Boolean:        false,
			SFX28Boolean:        false,
			SFX1Disable:         true,
			SFX2Disable:         true,
			SFX3Disable:         true,
			SFX4Disable:         true,
			SFX5Disable:         true,
			SFX6Disable:         true,
			SFX7Disable:         true,
			SFX8Disable:         true,
			SFX9Disable:         true,
			SFX10Disable:         true,
			SFX11Disable:         true,
			SFX12Disable:         true,
			SFX13Disable:         true,
			SFX14Disable:         true,
			SFX15Disable:         true,
			SFX16Disable:         true,
			SFX17Disable:         true,
			SFX18Disable:         true,
			SFX19Disable:         true,
			SFX20Disable:         true,
			SFX21Disable:         true,
			SFX22Disable:         true,
			SFX23Disable:         true,
			SFX24Disable:         true,
			SFX25Disable:         true,
			SFX26Disable:         true,
		//SOUND EFFECTS DATA
			SFXPlayer1: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"loopStart"  : 0.04,
										"loopEnd"  : 35.283,	
			  							"retrigger"  : false,
			  							"autostart"  : false,
			  							}).toMaster(),
			SFXPlayer2: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"loopStart"  : 0.04,
										"loopEnd"  : 35.283,
			  							"retrigger"  : false,
			  							"autostart"  : false,
			  							}).toMaster(),
			SFXPlayer3: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"loopStart"  : 0.04,
										"loopEnd"  : 35.283,
			  							"retrigger"  : false,
			  							"autostart"  : false,
			  							}).toMaster(),
			SFXPlayer4: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"loopStart"  : 0.04,
										"loopEnd"  : 35.283,
			  							"retrigger"  : false,
			  							"autostart"  : false,
			  							}).toMaster(),
			SFXPlayer5: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"loopStart"  : 0.04,
										"loopEnd"  : 35.283,
			  							"retrigger"  : false,
			  							"autostart"  : false,
			  							}).toMaster(),
			SFXPlayer6: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"loopStart"  : 0.04,
										"loopEnd"  : 35.283,
			  							"retrigger"  : false,
			  							"autostart"  : false,
			  							}).toMaster(),
			SFXPlayer7: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							"volume": 2
			  							}),
			SFXPlayer8: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							"volume": 2
			  							}),
			SFXPlayer9: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							"volume": 10
			  							}),
			SFXPlayer10: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : true,
			  							"volume": 6
			  							}),
			SFXPlayer11: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							"volume": 10
			  							}),
			SFXPlayer12: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							"volume": 6
			  							}),
			SFXPlayer13: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							"volume": 6
			  							}),
			SFXPlayer14: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							"volume": 12
			  							}),
			SFXPlayer15: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							"volume": 6
			  							}),
			SFXPlayer16: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							}),
			SFXPlayer17: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							"volume": 4
			  							}),
			SFXPlayer18: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							"volume": 4
			  							}),
			SFXPlayer19: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							"volume": -2
			  							}),
			SFXPlayer20: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							"volume": 4
			  							}),
			SFXPlayer21: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							}),
			SFXPlayer22: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"loopStart"  : 0.2,
										"loopEnd"  : 3.6,
			  							"retrigger"  : true,
			  							"volume": 6
			  							}),
			SFXPlayer23: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							"volume": 4
			  							}),
			SFXPlayer24: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : false,
			  							}),
			SFXPlayer25: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							}),
			SFXPlayer26: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  							"volume": 4
			  							}),
		//SOUND FX REPEAT BOOLEANS
			SFX1BooleanRepeat1:   false,
			SFX1BooleanRepeat2:   false,
			SFX1BooleanRepeat3:   false,
			SFX1BooleanRepeat4:   false,

			SFX2BooleanRepeat1:   false,
			SFX2BooleanRepeat2:   false,
			SFX2BooleanRepeat3:   false,
			SFX2BooleanRepeat4:   false,

			SFX3BooleanRepeat1:   false,
			SFX3BooleanRepeat2:   false,
			SFX3BooleanRepeat3:   false,
			SFX3BooleanRepeat4:   false,

			SFX4BooleanRepeat1:   false,
			SFX4BooleanRepeat2:   false,
			SFX4BooleanRepeat3:   false,
			SFX4BooleanRepeat4:   false,

			SFX5BooleanRepeat1:   false,
			SFX5BooleanRepeat2:   false,
			SFX5BooleanRepeat3:   false,
			SFX5BooleanRepeat4:   false,

			SFX6BooleanRepeat1:   false,
			SFX6BooleanRepeat2:   false,
			SFX6BooleanRepeat3:   false,
			SFX6BooleanRepeat4:   false,

			SFX8BooleanRepeat:   false,
			SFX9BooleanRepeat:   false,
			SFX10BooleanRepeat:   false,
			SFX11BooleanRepeat:   false,
			SFX12BooleanRepeat:   false,
			SFX13BooleanRepeat:   false,
			SFX14BooleanRepeat:   false,
			SFX15BooleanRepeat:   false,
			SFX16BooleanRepeat:   false,
		//REPEAT V MODELS
			SFX1MODEL:                  1,
			SFX2MODEL:                  1,
			SFX3MODEL:                  1,
			SFX4MODEL:                  1,
			SFX5MODEL:                  0,
			SFX6MODEL:                  0,
		//AUDIO ROUTING & EFFECTS
			musicReverb:            0,
			// MusicVolumeVerb:  		new Tone.Volume(),
			musicVol:  				-5,
			MusicVolumeMaster:      new Tone.Volume(0),
			masterTempo:            120,
			sfxChorus:   			0,
			fxChorus:               new Tone.Chorus(4, 3, 0.5),
			sfxDelay:               0,
			// fxDelay:  				new Tone.PingPongDelay("4n", 0.6),
			masterReverb:           0,
			SFXverb:                0,
			fxConvolver:      		new Tone.Convolver("../src/assets/cookieverb.wav"),
			// fxConvolver:			new Tone.Freeverb({
			// 						"roomSize" : .8, 
			// 						"dampening" : 1500
			// 						}),
			masterDistort:          0,
			fxDistort:              new Tone.Distortion(0.4),
			// masterCompressor:  		new Tone.Compressor({
			// 							"threshold" : -6,
			// 							"ratio" : 2,
			// 							"attack" : 0.001,
			// 							"release" : 0.01,
			// 							"knee" : 0
			// 							}),
			masterCompressor:       new Tone.Limiter(-3),
			// evilColor:     			new Tone.EQ3 ({
			// 							"low" : 0,
			// 							"mid" : 0,
			// 							"high" : 0,
			// 							"lowFrequency" : 500,
			// 							"highFrequency" : 1250
			// 							}),	
			evilLFO:   				new Tone.LFO({
										"type" : "sine",
										"min" : -14,
										"max" : 0,
										"phase" : 0,
										"frequency" : .1,
										"amplitude" : .5,
										"units" : Tone.Type.Default
										}).start(),	
			musicDestroy:    		0,
			musicDestroyDistortion: new Tone.Distortion(0.6),
			destroyIt:              true,
			autoFilter:             new Tone.AutoFilter({
									"frequency" : 10,
									"type" : "sine",
									"depth" : 1,
									"baseFrequency" : 1000,
									"octaves" : 4,
									"filter" : {
										"type" : "lowpass",
										"rolloff" : -24,
										"Q" : 1,
									}}).toMaster().start(),
			musicFilter:            0,
			nukeID:     			undefined,
			sfxVol:                 0,
			SFXSubVolume: 			new Tone.Volume(),
			SFXSubVolumeControl: 	new Tone.Volume(),
			MEOW: false,
			startAudioBoolean: true,
		}),
mounted(){

},
created(){
	this.audioLoading();
	// eventBus.$on('eventBus', ()  => {
	// 			  console.log("Oh, that's nice. I was loading shit");
	// 		});

	this.bufferLoading();
	//MASTER ROUTING
		this.audioRouting();
		Tone.Master.chain(this.masterCompressor);
	//TRANSPORT OPTIONS
		Tone.Transport.bpm.value = 120;
		Tone.Transport.loop = true;	
		setTimeout(this.startStop, 100);
	
	//ENGAGE FUTURE FIT TEXT
				// this.FutureFitEngage();
				// setInterval(this.FutureFitEngage, this.textTiming * 13);
		
	},

computed:{
	//CSS CLASS CHANGES
				//NAV BAR BUTTONS
					Section1Class(){
						return{
							"btn btn-blackwhiteneg": this.section1control,
							"btn btn-transparent": !this.section1control
						}
					},
					Section2Class(){
						return{
							"btn btn-blackwhiteneg": this.section2control,
							"btn btn-transparent": !this.section2control
						}
					},
					Section3Class(){
						return{
							"btn btn-blackwhiteneg": this.section3control,
							"btn btn-transparent": !this.section3control
						}
					},
				//AMBIENCE CLASS CHANGES
					ambience1Class(){
						return{
							"btn btn-success": this.ambience1Boolean,
							"btn btn-danger": !this.ambience1Boolean,
							"disabled": this.ambience1Disable
						}
					},
					ambience2Class(){
						return{
							"btn btn-success": this.ambience2Boolean,
							"btn btn-danger": !this.ambience2Boolean,
							"disabled": this.ambience2Disable
						}
					},
					ambience3Class(){
						return{
							"btn btn-success": this.ambience3Boolean,
							"btn btn-danger": !this.ambience3Boolean,
							"disabled": this.ambience3Disable
						}
					},
					ambience4Class(){
						return{
							"btn btn-success": this.ambience4Boolean,
							"btn btn-danger": !this.ambience4Boolean,
							"disabled": this.ambience4Disable
						}
					},
				//AMBIENCE ICON CSS
					ambience1Icon(){
						return {
							"fa fa-toggle-on": this.ambience1Boolean,
							"fa fa-toggle-off": !this.ambience1Boolean
						}
					},
					ambience2Icon(){
						return {
							"fa fa-toggle-on": this.ambience2Boolean,
							"fa fa-toggle-off": !this.ambience2Boolean
						}
					},
					ambience3Icon(){
						return {
							"fa fa-toggle-on": this.ambience3Boolean,
							"fa fa-toggle-off": !this.ambience3Boolean
						}
					},
					ambience4Icon(){
						return {
							"fa fa-toggle-on": this.ambience4Boolean,
							"fa fa-toggle-off": !this.ambience4Boolean
						}
					},
				//SOUND FX CLASS CHANGES
					SFX1Class(){
						return{
							"btn btn-danger": this.SFX1Boolean,
							"btn btn-success": !this.SFX1Boolean,
							"disabled": this.SFX1Disable

						}
					},
					SFX2Class(){
						return{
							"btn btn-danger": this.SFX2Boolean,
							"btn btn-success": !this.SFX2Boolean,
							"disabled": this.SFX2Disable
						}
					},
					SFX3Class(){
						return{
							"btn btn-danger": this.SFX3Boolean,
							"btn btn-success": !this.SFX3Boolean,
							"disabled": this.SFX3Disable,
						}
					},
					SFX4Class(){
						return{
							"btn btn-danger": this.SFX4Boolean,
							"btn btn-success": !this.SFX4Boolean,
							"disabled": this.SFX4Disable
						}
					},
					SFX5Class(){
						return{
							"btn btn-danger": this.SFX5Boolean,
							"btn btn-success": !this.SFX5Boolean,
							"disabled": this.SFX5Disable
						}
					},
					SFX6Class(){
						return{
							"btn btn-danger": this.SFX6Boolean,
							"btn btn-success": !this.SFX6Boolean,
							"disabled": this.SFX6Disable
						}
					},
					SFX7Class(){
						return{
							"btn btn-success": this.SFX7Boolean,
							"btn btn-danger": !this.SFX7Boolean,
							"disabled": this.SFX7Disable
						}
					},
					SFX8Class(){
						return{
							"btn btn-success": this.SFX8Boolean,
							"btn btn-danger": !this.SFX8Boolean,
							"disabled": this.SFX8Disable
						}
					},
					SFX9Class(){
						return{
							"btn btn-success": this.SFX9Boolean,
							"btn btn-danger": !this.SFX9Boolean,
							"disabled": this.SFX9Disable
						}
					},
					SFX10Class(){
						return{
							"btn btn-success": this.SFX10Boolean,
							"btn btn-danger": !this.SFX10Boolean,
							"disabled": this.SFX10Disable
						}
					},
					SFX11Class(){
						return{
							"btn btn-success": this.SFX11Boolean,
							"btn btn-danger": !this.SFX11Boolean,
							"disabled": this.SFX11Disable
						}
					},
					SFX12Class(){
						return{
							"btn btn-success": this.SFX12Boolean,
							"btn btn-danger": !this.SFX12Boolean,
							"disabled": this.SFX12Disable
						}
					},
					SFX13Class(){
						return{
							"btn btn-success": this.SFX13Boolean,
							"btn btn-danger": !this.SFX13Boolean,
							"disabled": this.SFX13Disable
						}
					},
					SFX14Class(){
						return{
							"btn btn-success": this.SFX14Boolean,
							"btn btn-danger": !this.SFX14Boolean,
							"disabled": this.SFX14Disable
						}
					},
					SFX15Class(){
						return{
							"btn btn-success": this.SFX15Boolean,
							"btn btn-danger": !this.SFX15Boolean,
							"disabled": this.SFX15Disable
						}
					},
					SFX16Class(){
						return{
							"btn btn-success": this.SFX16Boolean,
							"btn btn-danger": !this.SFX16Boolean,
							"disabled": this.SFX16Disable
						}
					},
					SFX17Class(){
						return{
							"btn btn-success": this.SFX17Boolean,
							"btn btn-danger": !this.SFX17Boolean,
							"disabled": this.SFX17Disable
						}
					},
					SFX18Class(){
						return{
							"btn btn-success": this.SFX18Boolean,
							"btn btn-danger": !this.SFX18Boolean,
							"disabled": this.SFX18Disable
						}
					},
					SFX19Class(){
						return{
							"btn btn-success": this.SFX19Boolean,
							"btn btn-danger": !this.SFX19Boolean,
							"disabled": this.SFX19Disable
						}
					},
					SFX20Class(){
						return{
							"btn btn-success": this.SFX20Boolean,
							"btn btn-danger": !this.SFX20Boolean,
							"disabled": this.SFX20Disable
						}
					},
					SFX21Class(){
						return{
							"btn btn-success": this.SFX21Boolean,
							"btn btn-danger": !this.SFX21Boolean,
							"disabled": this.SFX21Disable
						}
					},
					SFX22Class(){
						return{
							"btn btn-success": this.SFX22Boolean,
							"btn btn-danger": !this.SFX22Boolean,
							"disabled": this.SFX22Disable
						}
					},
					SFX23Class(){
						return{
							"btn btn-success": this.SFX23Boolean,
							"btn btn-danger": !this.SFX23Boolean,
							"disabled": this.SFX23Disable
						}
					},
					SFX24Class(){
						return{
							"btn btn-success": this.SFX24Boolean,
							"btn btn-danger": !this.SFX24Boolean,
							"disabled": this.SFX24Disable
						}
					},
					SFX25Class(){
						return{
							"btn btn-success": this.SFX25Boolean,
							"btn btn-danger": !this.SFX25Boolean,
							"disabled": this.SFX25Disable
						}
					},
					SFX26Class(){
						return{
							"btn btn-success": this.SFX26Boolean,
							"btn btn-danger": !this.SFX26Boolean,
							"disabled": this.SFX26Disable
						}
					},
					SFX27Class(){
						return{
							"btn btn-success": this.SFX27Boolean,
							"btn btn-danger": !this.SFX27Boolean
						}
					},
					SFX28Class(){
						return{
							"btn btn-success": this.SFX28Boolean,
							"btn btn-danger": !this.SFX28Boolean
						}
					},
				//SOUND FX REPEAT CLASS CHANGES
					SFX1ClassRepeat(){
						return{
							"btn btn-success": this.SFX1BooleanRepeat,
							"btn btn-blackwhite": !this.SFX1BooleanRepeat
						}
					},	
					SFX2ClassRepeat(){
						return{
							"btn btn-success": this.SFX2BooleanRepeat,
							"btn btn-blackwhite": !this.SFX2BooleanRepeat
						}
					},	
					SFX3ClassRepeat(){
						return{
							"btn btn-success": this.SFX3BooleanRepeat,
							"btn btn-blackwhite": !this.SFX3BooleanRepeat
						}
					},	
					SFX4ClassRepeat(){
						return{
							"btn btn-success": this.SFX4BooleanRepeat,
							"btn btn-blackwhite": !this.SFX4BooleanRepeat
						}
					},	
					SFX5ClassRepeat(){
						return{
							"btn btn-success": this.SFX5BooleanRepeat,
							"btn btn-blackwhite": !this.SFX5BooleanRepeat
						}
					},	
					SFX6ClassRepeat(){
						return{
							"btn btn-success": this.SFX6BooleanRepeat,
							"btn btn-blackwhite": !this.SFX6BooleanRepeat
						}
					},	
					SFX7ClassRepeat(){
						return{
							"btn btn-success": this.SFX7BooleanRepeat,
							"btn btn-blackwhite": !this.SFX7BooleanRepeat
						}
					},	
					SFX8ClassRepeat(){
						return{
							"btn btn-success": this.SFX8BooleanRepeat,
							"btn btn-blackwhite": !this.SFX8BooleanRepeat
						}
					},
					SFX9ClassRepeat(){
						return{
							"btn btn-success": this.SFX9BooleanRepeat,
							"btn btn-blackwhite": !this.SFX9BooleanRepeat
						}
					},
					SFX10ClassRepeat(){
						return{
							"btn btn-success": this.SFX10BooleanRepeat,
							"btn btn-blackwhite": !this.SFX10BooleanRepeat
						}
					},
					SFX11ClassRepeat(){
						return{
							"btn btn-success": this.SFX11BooleanRepeat,
							"btn btn-blackwhite": !this.SFX11BooleanRepeat
						}
					},
					SFX12ClassRepeat(){
						return{
							"btn btn-success": this.SFX12BooleanRepeat,
							"btn btn-blackwhite": !this.SFX12BooleanRepeat
						}
					},
					SFX13ClassRepeat(){
						return{
							"btn btn-success": this.SFX13BooleanRepeat,
							"btn btn-blackwhite": !this.SFX13BooleanRepeat
						}
					},	
					SFX14ClassRepeat(){
						return{
							"btn btn-success": this.SFX14BooleanRepeat,
							"btn btn-blackwhite": !this.SFX14BooleanRepeat
						}
					},	
					SFX15ClassRepeat(){
						return{
							"btn btn-success": this.SFX15BooleanRepeat,
							"btn btn-blackwhite": !this.SFX15BooleanRepeat
						}
					},
					SFX16ClassRepeat(){
						return{
							"btn btn-success": this.SFX16BooleanRepeat,
							"btn btn-blackwhite": !this.SFX16BooleanRepeat
						}
					},				
				//DESTROY
					destroyClass(){
						return{
							"btn btn-danger": this.destroyIt,
							"btn btn-success": !this.destroyIt
						}
					},
					musicNukeIcon(){
						return{
							"fa fa-bolt lg": this.destroyIt,
							"fa fa-bolt lg fa-counter-spin fa-fw": !this.destroyIt
						}
					},					
				//PLAY BUTTONS
					startStopIcon(){
						return {
							"fa fa-stop": this.startStopTrigger,
							"fa fa-play": !this.startStopTrigger,
						}
					},
					startStopClass(){
						return {
							"btn btn-danger": this.startStopTrigger,
							"btn btn-success": !this.startStopTrigger
						}
					},
	//AUDIO MIXING
		musicVolume1(){
			this.SFXPlayer1.volume.value = this.musicVol;
			this.SFXPlayer1.mute = this.SFX1Boolean;
			this.SFXPlayer1.playbackRate = this.SFX1MODEL;
		},
		musicVolume2(){
			this.SFXPlayer2.volume.value = this.musicVol;
			this.SFXPlayer2.mute = this.SFX2Boolean;
			this.SFXPlayer2.playbackRate = this.SFX1MODEL;
		},
		musicVolume3(){
			this.SFXPlayer3.volume.value = this.musicVol;
			this.SFXPlayer3.mute = this.SFX3Boolean;
			this.SFXPlayer3.playbackRate = this.SFX1MODEL;
		},
		musicVolume4(){
			this.SFXPlayer4.volume.value = this.musicVol;
			this.SFXPlayer4.mute = this.SFX4Boolean;
			this.SFXPlayer4.playbackRate = this.SFX1MODEL;
		},
		musicVolume5(){
			this.SFXPlayer5.volume.value = this.musicVol;
			this.SFXPlayer5.mute = this.SFX5Boolean;
			this.SFXPlayer5.playbackRate = this.SFX1MODEL;
		},
		musicVolume6(){
			this.SFXPlayer6.volume.value = this.musicVol;
			this.SFXPlayer6.mute = this.SFX6Boolean;
			this.SFXPlayer6.playbackRate = this.SFX1MODEL;
		},

		audioMixing(){
				// Tone.Transport.bpm.value = this.masterTempo;
				// this.fxDelay.wet.value = this.sfxDelay / 100;
				this.fxConvolver.wet.value = this.musicReverb / 100;
				this.fxChorus.wet.value = this.sfxChorus / 100;
				this.musicDestroyDistortion.wet.value = this.musicDestroy / 100;
				this.autoFilter.wet.value = this.musicFilter / 100;
				
				this.fxDistort.wet.value = this.masterDistort / 100;
				this.evilLFO.frequency.value = this.masterDistort / 50;
				this.SFXSubVolumeControl.volume.value = this.sfxVol;

		},
		ambienceMixing(){
				this.ambience1Player.volume.value = this.ambience1Vol;
				this.ambience2Player.volume.value = this.ambience2Vol;
				this.ambience3Player.volume.value = this.ambience3Vol;
				this.ambience4Player.volume.value = this.ambience4Vol;
		},
	//TRANSPORT EVENTS
		// transportEvents(){

		// 			var vm = this;
				
		// 				//4 Measure
		// 				Tone.Transport.scheduleRepeat(function(time){
							
		// 					if (vm.SFX1BooleanRepeat1 === true){
		// 						vm.SFX1();
		// 					};

		// 					if (vm.SFX2BooleanRepeat1 === true){
		// 						vm.SFX2();
		// 					};

		// 					if (vm.SFX3BooleanRepeat1 === true){
		// 						vm.SFX3();
		// 					};

							
		// 				}, "4m");

		// 				// 2 Measure
		// 				Tone.Transport.scheduleRepeat(function(time){
							
		// 					if (vm.SFX1BooleanRepeat2 === true){
		// 						vm.SFX1();
		// 					};

		// 					if (vm.SFX2BooleanRepeat2 === true){
		// 						vm.SFX2();
		// 					};

		// 					if (vm.SFX3BooleanRepeat2 === true){
		// 						vm.SFX3();
		// 					};

							
		// 				}, "2m");

		// 				//1 Measure
		// 				Tone.Transport.scheduleRepeat(function(time){
							
		// 					if (vm.SFX1BooleanRepeat3 === true){
		// 						vm.SFX1();
		// 					};

		// 					if (vm.SFX2BooleanRepeat3 === true){
		// 						vm.SFX2();
		// 					};

		// 					if (vm.SFX3BooleanRepeat3 === true){
		// 						vm.SFX3();
		// 					};

		// 					if (vm.SFX4BooleanRepeat1 === true){
		// 						vm.SFX4();
		// 					};

		// 					if (vm.SFX5BooleanRepeat1 === true){
		// 						vm.SFX5();
		// 					};

		// 					if (vm.SFX6BooleanRepeat1 === true){
		// 						vm.SFX6();
		// 					};


		// 				}, "1m");

		// 				// 1/4 Notes
		// 				Tone.Transport.scheduleRepeat(function(time){

							
		// 					if (vm.SFX1BooleanRepeat4 === true){
		// 						vm.SFX1();
		// 					};

		// 					if (vm.SFX2BooleanRepeat4 === true){
		// 						vm.SFX2();
		// 					};

		// 					if (vm.SFX3BooleanRepeat4 === true){
		// 						vm.SFX3();
		// 					};

		// 					if (vm.SFX4BooleanRepeat2 === true){
		// 						vm.SFX4();
		// 					};

		// 					if (vm.SFX5BooleanRepeat2 === true){
		// 						vm.SFX5();
		// 					};

		// 					if (vm.SFX6BooleanRepeat2 === true){
		// 						vm.SFX6();
		// 					};

		// 				}, "4n");

		// 				// 1/8th Notes
		// 				Tone.Transport.scheduleRepeat(function(time){

							
		// 					if (vm.SFX4BooleanRepeat3 === true){
		// 						vm.SFX4();
		// 					};

		// 					if (vm.SFX5BooleanRepeat3 === true){
		// 						vm.SFX5();
		// 					};

		// 					if (vm.SFX6BooleanRepeat3 === true){
		// 						vm.SFX6();
		// 					};
							
							
		// 				}, "8n");

		// 				// 1/16th Notes
		// 				Tone.Transport.scheduleRepeat(function(time){

							
		// 					if (vm.SFX4BooleanRepeat4 === true){
		// 						vm.SFX4();
		// 					};

		// 					if (vm.SFX5BooleanRepeat4 === true){
		// 						vm.SFX5();
		// 					};

		// 					if (vm.SFX6BooleanRepeat4 === true){
		// 						vm.SFX6();
		// 					};
							
							
		// 				}, "16n");

		// 			},	
		//REPEATS
					// SFX1Repeat(){
					// 	// this.SFX1BooleanRepeat = !this.SFX1BooleanRepeat;
					// 	if (this.SFX1MODEL == 4){
					// 		this.SFX1BooleanRepeat4 = true;
					// 		this.SFX1BooleanRepeat3 = false;
					// 		this.SFX1BooleanRepeat2 = false;
					// 		this.SFX1BooleanRepeat1 = false;

					// 	} else if (this.SFX1MODEL == 3){
					// 		this.SFX1BooleanRepeat4 = false;
					// 		this.SFX1BooleanRepeat3 = true;
					// 		this.SFX1BooleanRepeat2 = false;
					// 		this.SFX1BooleanRepeat1 = false;

					// 	} else if (this.SFX1MODEL == 2){
					// 		this.SFX1BooleanRepeat4 = false;
					// 		this.SFX1BooleanRepeat3 = false;
					// 		this.SFX1BooleanRepeat2 = true;
					// 		this.SFX1BooleanRepeat1 = false;

					// 	} else if (this.SFX1MODEL == 1){
					// 		this.SFX1BooleanRepeat4 = false;
					// 		this.SFX1BooleanRepeat3 = false;
					// 		this.SFX1BooleanRepeat2 = false;
					// 		this.SFX1BooleanRepeat1 = true;

					// 	} else if (this.SFX1MODEL == 0){
					// 		this.SFX1BooleanRepeat4 = false;
					// 		this.SFX1BooleanRepeat3 = false;
					// 		this.SFX1BooleanRepeat2 = false;
					// 		this.SFX1BooleanRepeat1 = false;
					// 	};
					// },
					// SFX2Repeat(){
					// 	// this.SFX1BooleanRepeat = !this.SFX1BooleanRepeat;
					// 	if (this.SFX2MODEL == 4){
					// 		this.SFX2BooleanRepeat4 = true;
					// 		this.SFX2BooleanRepeat3 = false;
					// 		this.SFX2BooleanRepeat2 = false;
					// 		this.SFX2BooleanRepeat1 = false;

					// 	} else if (this.SFX2MODEL == 3){
					// 		this.SFX2BooleanRepeat4 = false;
					// 		this.SFX2BooleanRepeat3 = true;
					// 		this.SFX2BooleanRepeat2 = false;
					// 		this.SFX2BooleanRepeat1 = false;

					// 	} else if (this.SFX2MODEL == 2){
					// 		this.SFX2BooleanRepeat4 = false;
					// 		this.SFX2BooleanRepeat3 = false;
					// 		this.SFX2BooleanRepeat2 = true;
					// 		this.SFX2BooleanRepeat1 = false;

					// 	} else if (this.SFX2MODEL == 1){
					// 		this.SFX2BooleanRepeat4 = false;
					// 		this.SFX2BooleanRepeat3 = false;
					// 		this.SFX2BooleanRepeat2 = false;
					// 		this.SFX2BooleanRepeat1 = true;

					// 	} else if (this.SFX2MODEL == 0){
					// 		this.SFX2BooleanRepeat4 = false;
					// 		this.SFX2BooleanRepeat3 = false;
					// 		this.SFX2BooleanRepeat2 = false;
					// 		this.SFX2BooleanRepeat1 = false;
					// 	};
					// },
					// SFX3Repeat(){
					// 	// this.SFX1BooleanRepeat = !this.SFX1BooleanRepeat;
					// 	if (this.SFX3MODEL == 4){
					// 		this.SFX3BooleanRepeat4 = true;
					// 		this.SFX3BooleanRepeat3 = false;
					// 		this.SFX3BooleanRepeat2 = false;
					// 		this.SFX3BooleanRepeat1 = false;

					// 	} else if (this.SFX3MODEL == 3){
					// 		this.SFX3BooleanRepeat4 = false;
					// 		this.SFX3BooleanRepeat3 = true;
					// 		this.SFX3BooleanRepeat2 = false;
					// 		this.SFX3BooleanRepeat1 = false;

					// 	} else if (this.SFX3MODEL == 2){
					// 		this.SFX3BooleanRepeat4 = false;
					// 		this.SFX3BooleanRepeat3 = false;
					// 		this.SFX3BooleanRepeat2 = true;
					// 		this.SFX3BooleanRepeat1 = false;

					// 	} else if (this.SFX3MODEL == 1){
					// 		this.SFX3BooleanRepeat4 = false;
					// 		this.SFX3BooleanRepeat3 = false;
					// 		this.SFX3BooleanRepeat2 = false;
					// 		this.SFX3BooleanRepeat1 = true;

					// 	} else if (this.SFX3MODEL == 0){
					// 		this.SFX3BooleanRepeat4 = false;
					// 		this.SFX3BooleanRepeat3 = false;
					// 		this.SFX3BooleanRepeat2 = false;
					// 		this.SFX3BooleanRepeat1 = false;
					// 	};
					// },
					// SFX4Repeat(){
					// 	// this.SFX1BooleanRepeat = !this.SFX1BooleanRepeat;
					// 	if (this.SFX4MODEL == 4){
					// 		this.SFX4BooleanRepeat4 = true;
					// 		this.SFX4BooleanRepeat3 = false;
					// 		this.SFX4BooleanRepeat2 = false;
					// 		this.SFX4BooleanRepeat1 = false;

					// 	} else if (this.SFX4MODEL == 3){
					// 		this.SFX4BooleanRepeat4 = false;
					// 		this.SFX4BooleanRepeat3 = true;
					// 		this.SFX4BooleanRepeat2 = false;
					// 		this.SFX4BooleanRepeat1 = false;

					// 	} else if (this.SFX4MODEL == 2){
					// 		this.SFX4BooleanRepeat4 = false;
					// 		this.SFX4BooleanRepeat3 = false;
					// 		this.SFX4BooleanRepeat2 = true;
					// 		this.SFX4BooleanRepeat1 = false;

					// 	} else if (this.SFX4MODEL == 1){
					// 		this.SFX4BooleanRepeat4 = false;
					// 		this.SFX4BooleanRepeat3 = false;
					// 		this.SFX4BooleanRepeat2 = false;
					// 		this.SFX4BooleanRepeat1 = true;

					// 	} else if (this.SFX4MODEL == 0){
					// 		this.SFX4BooleanRepeat4 = false;
					// 		this.SFX4BooleanRepeat3 = false;
					// 		this.SFX4BooleanRepeat2 = false;
					// 		this.SFX4BooleanRepeat1 = false;
					// 	};
					// },
					// SFX5Repeat(){
					// 	// this.SFX1BooleanRepeat = !this.SFX1BooleanRepeat;
					// 	if (this.SFX5MODEL == 4){
					// 		this.SFX5BooleanRepeat4 = true;
					// 		this.SFX5BooleanRepeat3 = false;
					// 		this.SFX5BooleanRepeat2 = false;
					// 		this.SFX5BooleanRepeat1 = false;

					// 	} else if (this.SFX5MODEL == 3){
					// 		this.SFX5BooleanRepeat4 = false;
					// 		this.SFX5BooleanRepeat3 = true;
					// 		this.SFX5BooleanRepeat2 = false;
					// 		this.SFX5BooleanRepeat1 = false;

					// 	} else if (this.SFX5MODEL == 2){
					// 		this.SFX5BooleanRepeat4 = false;
					// 		this.SFX5BooleanRepeat3 = false;
					// 		this.SFX5BooleanRepeat2 = true;
					// 		this.SFX5BooleanRepeat1 = false;

					// 	} else if (this.SFX5MODEL == 1){
					// 		this.SFX5BooleanRepeat4 = false;
					// 		this.SFX5BooleanRepeat3 = false;
					// 		this.SFX5BooleanRepeat2 = false;
					// 		this.SFX5BooleanRepeat1 = true;

					// 	} else if (this.SFX5MODEL == 0){
					// 		this.SFX5BooleanRepeat4 = false;
					// 		this.SFX5BooleanRepeat3 = false;
					// 		this.SFX5BooleanRepeat2 = false;
					// 		this.SFX5BooleanRepeat1 = false;
					// 	};
					// },
					// SFX6Repeat(){
					// 	// this.SFX1BooleanRepeat = !this.SFX1BooleanRepeat;
					// 	if (this.SFX6MODEL == 4){
					// 		this.SFX6BooleanRepeat4 = true;
					// 		this.SFX6BooleanRepeat3 = false;
					// 		this.SFX6BooleanRepeat2 = false;
					// 		this.SFX6BooleanRepeat1 = false;

					// 	} else if (this.SFX6MODEL == 3){
					// 		this.SFX6BooleanRepeat4 = false;
					// 		this.SFX6BooleanRepeat3 = true;
					// 		this.SFX6BooleanRepeat2 = false;
					// 		this.SFX6BooleanRepeat1 = false;

					// 	} else if (this.SFX6MODEL == 2){
					// 		this.SFX6BooleanRepeat4 = false;
					// 		this.SFX6BooleanRepeat3 = false;
					// 		this.SFX6BooleanRepeat2 = true;
					// 		this.SFX6BooleanRepeat1 = false;

					// 	} else if (this.SFX6MODEL == 1){
					// 		this.SFX6BooleanRepeat4 = false;
					// 		this.SFX6BooleanRepeat3 = false;
					// 		this.SFX6BooleanRepeat2 = false;
					// 		this.SFX6BooleanRepeat1 = true;

					// 	} else if (this.SFX6MODEL == 0){
					// 		this.SFX6BooleanRepeat4 = false;
					// 		this.SFX6BooleanRepeat3 = false;
					// 		this.SFX6BooleanRepeat2 = false;
					// 		this.SFX6BooleanRepeat1 = false;
					// 	};
					// },
	},
methods: {
	startAudio(){
				StartAudioContext(Tone.context, "#ambienceBtns");
				},
	//BUFFER LOADING	
		bufferLoading(){
				// this.bufferLoadingBarCreate();

				var vm = this;

				Tone.Buffer.on('progress', function(){
					vm.bufferProgress++;

				})
				Tone.Buffer.on('load', function(){
					// vm.discoLogo = true;
					setTimeout(vm.musicStart, 100);
					vm.FutureFitFunc2();
					
					vm.LoadingText2 = "Add Some Horrible Sounds";
					vm.LoadingText3 = "Play The Skeleton Song";
					// vm.hideSection2Page();
					// setTimeout(vm.showSection3Page, 200);
				})

		},
		// FutureFitEngage(){
		// 			this.FutureFitFunc2();
		// 			setTimeout(this.FutureFitFunc2, 2000);
		// 			// setTimeout(this.FutureFitFunc3, 3250);
		// 			// setTimeout(this.FutureFitFunc4, 3500);
		// 			// setTimeout(this.FutureFitFunc5, 4250);
		// 			// setTimeout(this.FutureFitFunc6, 5000);
		// 		},
		// 		FutureFitFunc1(){
		// 			this.FutureFit = 'All Loaded!';
		// 		},
				FutureFitFunc2(){
					this.FutureFit = 'Halloween';
				},
	//AUDIO ROUTING
		musicStart(){
			this.SFXPlayer1.start();
			this.SFXPlayer2.start();
			this.SFXPlayer3.start();
			this.SFXPlayer4.start();
			this.SFXPlayer5.start();
			this.SFXPlayer6.start();

			this.SFXPlayer1.connect(this.MusicVolumeMaster);
			this.SFXPlayer2.connect(this.MusicVolumeMaster);
			this.SFXPlayer3.connect(this.MusicVolumeMaster);
			this.SFXPlayer4.connect(this.MusicVolumeMaster);
			this.SFXPlayer5.connect(this.MusicVolumeMaster);
			this.SFXPlayer6.connect(this.MusicVolumeMaster);

			this.MusicVolumeMaster.chain(
				this.fxChorus, 
				this.fxConvolver, 
				this.musicDestroyDistortion, 
				this.autoFilter, 
				Tone.Master);

			// this.musicLFO.connect(this.musicWobble.volume);

			// this.MusicVolumeVerb.chain(this.fxConvolver, Tone.Master);

			},
		audioRouting(){
			// this.ambience1Player.connect(this.SFXSubVolume);
			// this.ambience2Player.connect(this.SFXSubVolume);
			// this.ambience3Player.connect(this.SFXSubVolume);
			// this.ambience4Player.connect(this.SFXSubVolume);

			this.SFXPlayer7.connect(this.SFXSubVolume);
			this.SFXPlayer8.connect(this.SFXSubVolume);
			this.SFXPlayer9.connect(this.SFXSubVolume);
			this.SFXPlayer10.connect(this.SFXSubVolume);
			this.SFXPlayer11.connect(this.SFXSubVolume);
			this.SFXPlayer12.connect(this.SFXSubVolume);
			this.SFXPlayer13.connect(this.SFXSubVolume);
			this.SFXPlayer14.connect(this.SFXSubVolume);
			this.SFXPlayer15.connect(this.SFXSubVolume);
			this.SFXPlayer16.connect(this.SFXSubVolume);
			this.SFXPlayer17.connect(this.SFXSubVolume);
			this.SFXPlayer18.connect(this.SFXSubVolume);
			this.SFXPlayer19.connect(this.SFXSubVolume);
			this.SFXPlayer20.connect(this.SFXSubVolume);
			this.SFXPlayer21.connect(this.SFXSubVolume);
			this.SFXPlayer22.connect(this.SFXSubVolume);
			this.SFXPlayer23.connect(this.SFXSubVolume);
			this.SFXPlayer24.connect(this.SFXSubVolume);
			this.SFXPlayer25.connect(this.SFXSubVolume);
			this.SFXPlayer26.connect(this.SFXSubVolume);
			
			// this.SFXSubVolume.send("reverb", 0);
			// this.fxConvolver.receive("reverb");

			this.SFXSubVolume.chain(this.fxDistort, this.SFXSubVolumeControl, Tone.Master);

			this.evilLFO.connect(this.SFXSubVolume.volume);

		},
	//AUDIO LOADING
				audioLoading(){
					var vm = this;
					//AMBIENCE LOADING
					this.ambience1Player.load("../src/assets/storm.mp3", function(){
						vm.ambience1Disable = false;
					});

					this.ambience2Player.load("../src/assets/graveyard.mp3", function(){
						vm.ambience2Disable = false;
					});

					this.ambience3Player.load("../src/assets/sewer.mp3", function(){
						vm.ambience3Disable = false;
					});

					this.ambience4Player.load("../src/assets/lab.mp3", function(){
						vm.ambience4Disable = false;
						vm.LoadingText1 = "Choose Your Background Theme";
					});
					//SFX LOADING
					this.SFXPlayer11.load("../src/assets/evillaugh.mp3", function(){
						vm.SFX11Disable = false;
					});

					this.SFXPlayer21.load("../src/assets/whisper.mp3", function(){
						vm.SFX21Disable = false;
					});

					this.SFXPlayer9.load("../src/assets/clapsquish.mp3", function(){
						vm.SFX9Disable = false;
					});

					this.SFXPlayer7.load("../src/assets/zombiegrowl.mp3", function(){
						vm.SFX7Disable = false;
					});

					this.SFXPlayer8.load("../src/assets/zombieangry.mp3", function(){
						vm.SFX8Disable = false;
					});

					this.SFXPlayer12.load("../src/assets/monster.mp3", function(){
						vm.SFX12Disable = false;
					});

					this.SFXPlayer10.load("../src/assets/bird.mp3", function(){
						vm.SFX10Disable = false;
					});

					this.SFXPlayer13.load("../src/assets/chainsaw.mp3", function(){
						vm.SFX13Disable = false;
					});

					this.SFXPlayer14.load("../src/assets/knife.mp3", function(){
						vm.SFX14Disable = false;
					});

					this.SFXPlayer15.load("../src/assets/knifecut.mp3", function(){
						vm.SFX15Disable = false;
					});

					this.SFXPlayer16.load("../src/assets/match.mp3", function(){
						vm.SFX16Disable = false;
					});

					this.SFXPlayer23.load("../src/assets/scarymetal.mp3", function(){
						vm.SFX23Disable = false;
					});

					this.SFXPlayer17.load("../src/assets/wormhole.mp3", function(){
						vm.SFX17Disable = false;
					});

					this.SFXPlayer18.load("../src/assets/drama.mp3", function(){
						vm.SFX18Disable = false;
					});

					this.SFXPlayer19.load("../src/assets/creation.mp3", function(){
						vm.SFX19Disable = false;
					});

					this.SFXPlayer20.load("../src/assets/saturn.mp3", function(){
						vm.SFX20Disable = false;
					});

					this.SFXPlayer22.load("../src/assets/insects.mp3", function(){
						vm.SFX22Disable = false;
					});

					this.SFXPlayer24.load("../src/assets/biosuit.mp3", function(){
						vm.SFX24Disable = false;
					});

					this.SFXPlayer25.load("../src/assets/screams.mp3", function(){
						vm.SFX25Disable = false;
					});

					this.SFXPlayer26.load("../src/assets/sub.mp3", function(){
						vm.SFX26Disable = false;
					});

					//MUSIC LOADING
					this.SFXPlayer1.load("../src/assets/accordion.mp3", function(){
						vm.SFX1Disable = false;
					});

					this.SFXPlayer2.load("../src/assets/bass.mp3", function(){
						vm.SFX2Disable = false;
					});

					this.SFXPlayer3.load("../src/assets/sax.mp3", function(){
						vm.SFX3Disable = false;
					});

					this.SFXPlayer4.load("../src/assets/mando.mp3", function(){
						vm.SFX4Disable = false;
					});

					this.SFXPlayer5.load("../src/assets/fiddle.mp3", function(){
						vm.SFX5Disable = false;
					});

					this.SFXPlayer6.load("../src/assets/gtr.mp3", function(){
						vm.SFX6Disable = false;
					});

				},
	//DESTORY IT
		destroyFunc(){
			this.destroyIt = !this.destroyIt;

			var num = [1500, 2200, 3500, 10000, 15000]
			var item = num[Math.floor(Math.random()*num.length)];

			if (this.destroyIt === false){
				
				this.sfxChorus = 85;
				this.musicReverb = 85;
				this.musicDestroy = 35;
				// this.musicVol = 6;
				this.SFX1MODEL = .2;
				this.musicFilter = 70;

				this.nukeID = setInterval(this.nukeTiming, item);

				this.SkeletonDance = "That's The Spirit"
				this.SFXPlayer23.start();


			} else if (this.destroyIt === true) {
				this.sfxChorus = 0;
				this.musicReverb = 0;
				this.musicDestroy = 0;
				// this.musicVol = 0;
				this.SFX1MODEL = 1;
				this.musicFilter = 0;

				clearInterval(this.nukeID);

				this.SkeletonDance = "Summon The Music Demon"
			}
		},
		nukeTiming(){
			var num = [.1, .2, .3, .4, .5, .6, .7, .8, .9, 1, 1.1, 1.2, 1.3, 1.5, 1.8, 2]
			
			var item = num[Math.floor(Math.random()*num.length)];
			
			this.SFX1MODEL = item;

			console.log(item);

			// this.SFX1MODEL = 
			// this.nukeTime1();
			// setTimeout(this.nukeTime2, 500);
			// setTimeout(this.nukeTime3, 1250);
			// setTimeout(this.nukeTime4, 1500);
			// setTimeout(this.nukeTime5, 1750);
			// setTimeout(this.nukeTime6, 3500);
			// setTimeout(this.nukeTime7, 5500);
			// setTimeout(this.nukeTime8, 6000);
			// setTimeout(this.nukeTime9, 6500);

		},
		// nukeTime1(){
		// 	this.SFX1MODEL = .4;
		// },
		// nukeTime2(){
		// 	this.SFX1MODEL = .5;
		// },
		// nukeTime3(){
		// 	this.SFX1MODEL = .6;
		// },
		// nukeTime4(){
		// 	this.SFX1MODEL = .7;
		// },
		// nukeTime5(){
		// 	this.SFX1MODEL = .8;
		// },
		// nukeTime6(){
		// 	this.SFX1MODEL = 1.25;
		// },
		// nukeTime7(){
		// 	this.SFX1MODEL = 1.65;
		// },
		// nukeTime8(){
		// 	this.SFX1MODEL = .8;
		// },
		// nukeTime9(){
		// 	this.SFX1MODEL = .6;
		// },
	//SOUND EFFECTS REPEAT
					SFX7Repeat(){
						this.SFX7BooleanRepeat = !this.SFX7BooleanRepeat;
					},
					SFX8Repeat(){
						this.SFX8BooleanRepeat = !this.SFX8BooleanRepeat;
					},
					SFX9Repeat(){
						this.SFX9BooleanRepeat = !this.SFX9BooleanRepeat;
					},
					SFX10Repeat(){
						this.SFX10BooleanRepeat = !this.SFX10BooleanRepeat;
					},
					SFX11Repeat(){
						this.SFX11BooleanRepeat = !this.SFX11BooleanRepeat;
					},
					SFX12Repeat(){
						this.SFX12BooleanRepeat = !this.SFX12BooleanRepeat;
					},
					SFX13Repeat(){
						this.SFX13BooleanRepeat = !this.SFX13BooleanRepeat;
					},
					SFX14Repeat(){
						this.SFX14BooleanRepeat = !this.SFX14BooleanRepeat;
					},
					SFX15Repeat(){
						this.SFX15BooleanRepeat = !this.SFX15BooleanRepeat;
					},
					SFX16Repeat(){
						this.SFX16BooleanRepeat = !this.SFX16BooleanRepeat;
					},
	//SOUND EFFECTS HITS
					SFX1(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX1Boolean = !this.SFX1Boolean;
						if (this.SFX1Boolean === true){
							this.SFXPlayer1.mute = true;
						} else if (this.SFX1Boolean === false){
							this.SFXPlayer1.mute = false;
						}
						// this.SFX1Boolean = true;
						// this.SFXPlayer1.start();
						// setTimeout(this.SFX1false, 500);
					},
					SFX2(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX2Boolean = !this.SFX2Boolean;
						if (this.SFX2Boolean === true){
							this.SFXPlayer2.mute = true;
						} else if (this.SFX2Boolean === false){
							this.SFXPlayer2.mute = false;
						}

						// this.SFX2Boolean = true;
						// this.SFXPlayer2.start();
						// setTimeout(this.SFX2false, 500);
					},
					SFX3(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX3Boolean = !this.SFX3Boolean;
						if (this.SFX3Boolean === true){
							this.SFXPlayer3.mute = true;
						} else if (this.SFX3Boolean === false){
							this.SFXPlayer3.mute = false;
						}

						// this.SFX3Boolean = true;
						// this.SFXPlayer3.start();
						// setTimeout(this.SFX3false, 500);
					},
					SFX4(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX4Boolean = !this.SFX4Boolean;
						if (this.SFX4Boolean === true){
							this.SFXPlayer4.mute = true;
						} else if (this.SFX4Boolean === false){
							this.SFXPlayer4.mute = false;
						}

						// this.SFX4Boolean = true;
						// this.SFXPlayer4.start();
						// setTimeout(this.SFX4false, 100);
					},
					SFX5(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX5Boolean = true;
						this.SFXPlayer5.start();
						setTimeout(this.SFX5false, 100);
					},
					SFX6(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX6Boolean = true;
						this.SFXPlayer6.start();
						setTimeout(this.SFX6false, 100);
					},
					SFX7(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX7Boolean = true;
						this.SFXPlayer7.start();
						setTimeout(this.SFX7false, 1000);
					},
					SFX8(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX8Boolean = true;
						this.SFXPlayer8.start();
						setTimeout(this.SFX8false, 500);
					},
					SFX9(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX9Boolean = true;
						this.SFXPlayer9.start();
						setTimeout(this.SFX9false, 850);
					},
					SFX10(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						// this.SFX10Boolean = true;
						// this.SFXPlayer10.start();
						// setTimeout(this.SFX10false, 800);

						this.SFX10Boolean = !this.SFX10Boolean;
						if (this.SFX10Boolean === true){
							this.SFXPlayer10.start();
						}
						else if (this.SFX10Boolean === false){
							this.SFXPlayer10.stop();
						}
						setTimeout(this.SFX24false, 2270);
					},
					SFX11(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX11Boolean = true;
						this.SFXPlayer11.start();
						setTimeout(this.SFX11false, 3800);
					},
					SFX12(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX12Boolean = true;
						this.SFXPlayer12.start();
						setTimeout(this.SFX12false, 4000);
					},
					SFX13(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX13Boolean = true;
						this.SFXPlayer13.start();
						setTimeout(this.SFX13false, 4000);
					},
					SFX14(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX14Boolean = true;
						this.SFXPlayer14.start();
						setTimeout(this.SFX14false, 1000);
					},
					SFX15(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX15Boolean = true;
						this.SFXPlayer15.start();
						setTimeout(this.SFX15false, 1300);
					},
					SFX16(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX16Boolean = true;
						this.SFXPlayer16.start();
						setTimeout(this.SFX16false, 2500);
					},
					SFX17(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX17Boolean = true;
						this.SFXPlayer17.start();
						setTimeout(this.SFX17false, 1900);
					},
					SFX18(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX18Boolean = true;
						this.SFXPlayer18.start();
						setTimeout(this.SFX18false, 5000);
					},
					SFX19(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX19Boolean = true;
						this.SFXPlayer19.start();
						setTimeout(this.SFX19false, 6000);
					},
					SFX20(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX20Boolean = true;
						this.SFXPlayer20.start();
						setTimeout(this.SFX20false, 4000);
					},
					SFX21(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX21Boolean = true;
						this.SFXPlayer21.start();
						setTimeout(this.SFX21false, 3700);
					},
					SFX22(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						// this.SFX22Boolean = true;
						// this.SFXPlayer22.start();
						// setTimeout(this.SFX22false, 2270);

						this.SFX22Boolean = !this.SFX22Boolean;
						if (this.SFX22Boolean === true){
							this.SFXPlayer22.start();
						}
						else if (this.SFX22Boolean === false){
							this.SFXPlayer22.stop();
						}
						setTimeout(this.SFX24false, 2270);
					},
					SFX23(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX23Boolean = true;
						this.SFXPlayer23.start();
						setTimeout(this.SFX23false, 800);
					},
					SFX24(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX24Boolean = !this.SFX24Boolean;
						if (this.SFX24Boolean === true){
							this.SFXPlayer24.start();
						}
						else if (this.SFX24Boolean === false){
							this.SFXPlayer24.stop();
						}
						setTimeout(this.SFX24false, 15000);
					},
					SFX25(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX25Boolean = true;
						this.SFXPlayer25.start();
						setTimeout(this.SFX25false, 3000);
					},
					SFX26(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.SFX26Boolean = true;
						this.SFXPlayer26.start();
						setTimeout(this.SFX26false, 5700);
					},
	//AMBIENCE PLAY STOPS
					ambience1Func(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						
						this.ambience1Boolean = !this.ambience1Boolean;
						if (this.ambience1Boolean === true){
							this.ambience1Player.start();
						} else if (this.ambience1Boolean === false){
							this.ambience1Player.stop();
						}	
					},
					ambience2Func(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.ambience2Boolean = !this.ambience2Boolean;
						if (this.ambience2Boolean === true){
							this.ambience2Player.start();
						} else if (this.ambience2Boolean === false){
							this.ambience2Player.stop();
						}	
					},
					ambience3Func(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.ambience3Boolean = !this.ambience3Boolean;
						if (this.ambience3Boolean === true){
							this.ambience3Player.start();
						} else if (this.ambience3Boolean === false){
							this.ambience3Player.stop();
						}	
					},
					ambience4Func(){
						if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
						this.ambience4Boolean = !this.ambience4Boolean;
						if (this.ambience4Boolean === true){
							this.ambience4Player.start();
						} else if (this.ambience4Boolean === false){
							this.ambience4Player.stop();
						}	
					},
	//TRANSPORT START N STOP
					startStop(){
					// this.startStopTrigger = !this.startStopTrigger;
					// 	if (this.startStopTrigger === true){
					// 		Tone.Transport.start();
					// 	} else if (this.startStopTrigger === false){
					// 		Tone.Transport.stop();
					// 	}	
					Tone.Transport.start();
					},
	//FUTURE FIT TEXT
				// FutureFitEngage(){
				// 	setTimeout(this.FutureFitFunc1, this.textTiming);
				// 	setTimeout(this.FutureFitFunc2, this.textTiming * 10);
				// 	setTimeout(this.FutureFitFunc3, this.textTiming * 11);
				// 	setTimeout(this.FutureFitFunc4, this.textTiming * 12);
				// 	// setTimeout(this.FutureFitFunc5, this.textTiming * 5);
				// 	// setTimeout(this.FutureFitFunc6, this.textTiming * 6);
				// 	// setTimeout(this.FutureFitFunc7, this.textTiming * 7);
				// 	// setTimeout(this.FutureFitFunc8, this.textTiming * 8);
				// 	// setTimeout(this.FutureFitFunc9, texttiming x9);
				// 	// setTimeout(this.FutureFitFunc10, texttiming x10);
				// 	// setTimeout(this.FutureFitFunc11, texttiming x);
				// 	// setTimeout(this.FutureFitFunc12, texttiming x2);
				// 	// setTimeout(this.FutureFitFunc13, texttiming x2);
				// 	// setTimeout(this.FutureFitFunc14, texttiming x2);
				// 	// setTimeout(this.FutureFitFunc15, texttiming x2);
				// 	// setTimeout(this.FutureFitFunc16, texttiming x2);
				// 	// setTimeout(this.FutureFitFunc17, texttiming x2);
				// 	// setTimeout(this.FutureFitFunc18, texttiming x2);
				// 	// setTimeout(this.FutureFitFunc19, texttiming x2);
				// 	// setTimeout(this.FutureFitFunc20, texttiming x2);
				// },
				// FutureFitFunc1(){
				// 	this.FutureFit = 'Halloween';
				// },
				// FutureFitFunc2(){
				// 	this.FutureFit = 'Build';
				// },
				// FutureFitFunc3(){
				// 	this.FutureFit = 'your';
				// },
				// FutureFitFunc4(){
				// 	this.FutureFit = 'sound.';
				// },
				// FutureFitFunc5(){
				// 	this.FutureFit = 'Combined.';
				// },
				// FutureFitFunc6(){
				// 	this.FutureFit = 'meal.';
				// },
				// FutureFitFunc7(){
				// 	this.FutureFit = 'of';
				// },
				// FutureFitFunc8(){
				// 	this.FutureFit = 'sneezing';
				// },
				// FutureFitFunc9(){
				// 	this.FutureFit = 'to';
				// },
				// FutureFitFunc10(){
				// 	this.FutureFit = 'work';
				// },
				// FutureFitFunc11(){
				// 	this.FutureFit = 'with';
				// },
				// FutureFitFunc12(){
				// 	this.FutureFit = 'web';
				// },
				// FutureFitFunc13(){
				// 	this.FutureFit = 'audio';
				// },
				// FutureFitFunc14(){
				// 	this.FutureFit = 'and';
				// },
				// FutureFitFunc15(){
				// 	this.FutureFit = 'create';
				// },
				// FutureFitFunc16(){
				// 	this.FutureFit = 'wild';
				// },
				// FutureFitFunc17(){
				// 	this.FutureFit = 'experiments';
				// },
				// FutureFitFunc18(){
				// 	this.FutureFit = 'but';
				// },
				// FutureFitFunc19(){
				// 	this.FutureFit = 'also';
				// },
				// FutureFitFunc20(){
				// 	this.FutureFit = 'I jam';
				// },
	//DOM SHOW AND HIDE
				//MAIN NAV BAR BUTTON CONTROL
					// Section1Func(){
					// 	this.section1control = !this.section1control;
					// 	if (this.section1control === true) {
					// 		setTimeout(this.showSection1Page, 300);

					// 		//HIDE WELCOME TEXT
					// 		this.hideWelcomeText();

					// 		//HIDE SECTION 2
					// 		this.hideSection2Page();
					// 		this.section2control = false;

					// 		//HIDE SECTION 3
					// 		this.hideSection3Page();
					// 		this.section3control = false;
													
					// 	} else if (this.section1control === false){
					// 		this.showSection1 = false;
					// 		this.section2control = false;
					// 		this.section3control = false;

					// 		if (this.section1control === false 
					// 			&& this.section2control === false 
					// 			&& this.section3control === false) {
					// 		setTimeout(this.showWelcomeText, 300);
					// 		}
					// 	}
					// },
					// Section2Func(){
					// 	this.section2control = !this.section2control;
					// 	if (this.section2control === true){
					// 		setTimeout(this.showSection2Page, 300);

					// 		//HIDE WELCOME TEXT
					// 		this.hideWelcomeText();

					// 		//HIDE SECTION 1
					// 		this.hideSection1Page();
					// 		this.section1control = false;

					// 		//HIDE SECTION 3
					// 		this.hideSection3Page();
					// 		this.section3control = false;

					// 	} else if (this.section2control === false){
					// 		this.showSection2 = false;
					// 		this.section1control = false;
					// 		this.section3control = false;

					// 		if (this.section1control === false 
					// 			&& this.section2control === false 
					// 			&& this.section3control === false) {
					// 		setTimeout(this.showWelcomeText, 300);
					// 		}
					// 	}

					// },
					// Section3Func(){
					// 	this.section3control = !this.section3control;
					// 	if (this.section3control === true) {
					// 		setTimeout(this.showSection3Page, 400);
							
					// 		//HIDE WELCOME TEXT
					// 		this.hideWelcomeText();

					// 		//HIDE SECTION 1
					// 		this.hideSection1Page();
					// 		this.section1control = false;

					// 		//HIDE SECTION 2
					// 		this.hideSection2Page();
					// 		this.section2control = false;
							
					// 	} else if (this.section3control === false){
					// 		this.showSection3 = false;
					// 		this.section1control = false;
					// 		this.section2control = false;

					// 		if (this.section1control === false 
					// 			&& this.section2control === false 
					// 			&& this.section3control === false) {
					// 		setTimeout(this.showWelcomeText, 1000);
					// 		}
					// 	} 
					// },
	//DOM HIDE AND SHOW METHODS TO CALL
				//MAIN NAV BAR
					showSectionPage(){
						this.showSection = true;
					},
					hideSectionPage(){
						this.showSection = false;
					},
					showHelpPage(){
						this.showHelp = true;
					},
					hideHelpPage(){
						this.showHelp = false;
					},
					showDiscoPage(){
						this.discoLogo = true;
					},
					hideDiscoPage(){
						this.discoLogo = false;
					},
					// showWelcomeText(){
					// 	this.WelcomeText = true;

					// 	this.showSection1 = false; 
					// 	this.showSection2 = false;
					// 	this.showSection3 = false;

					// 	this.section1control = false;
					// 	this.section2control = false;
					// 	this.section3control = false;
					// },
					// hideWelcomeText(){
					// 	this.WelcomeText = false;
					// },
				//SFX BOOLEAN CALLS
					SFX1false(){
						this.SFX1Boolean = false;
					},
					SFX2false(){
						this.SFX2Boolean = false;
					},
					SFX3false(){
						this.SFX3Boolean = false;
					},
					SFX4false(){
						this.SFX4Boolean = false;
					},
					SFX5false(){
						this.SFX5Boolean = false;
					},
					SFX6false(){
						this.SFX6Boolean = false;
					},
					SFX7false(){
						this.SFX7Boolean = false;
					},
					SFX8false(){
						this.SFX8Boolean = false;
					},
					SFX9false(){
						this.SFX9Boolean = false;
					},
					SFX10false(){
						this.SFX10Boolean = false;
					},
					SFX11false(){
						this.SFX11Boolean = false;
					},
					SFX12false(){
						this.SFX12Boolean = false;
					},
					SFX13false(){
						this.SFX13Boolean = false;
					},
					SFX14false(){
						this.SFX14Boolean = false;
					},
					SFX15false(){
						this.SFX15Boolean = false;
					},
					SFX16false(){
						this.SFX16Boolean = false;
					},
					SFX17false(){
						this.SFX17Boolean = false;
					},
					SFX18false(){
						this.SFX18Boolean = false;
					},
					SFX19false(){
						this.SFX19Boolean = false;
					},
					SFX20false(){
						this.SFX20Boolean = false;
					},
					SFX21false(){
						this.SFX21Boolean = false;
					},
					SFX22false(){
						this.SFX22Boolean = false;
					},
					SFX23false(){
						this.SFX23Boolean = false;
					},
					SFX24false(){
						this.SFX24Boolean = false;
					},
					SFX25false(){
						this.SFX25Boolean = false;
					},
					SFX26false(){
						this.SFX26Boolean = false;
					},
					SFX27false(){
						this.SFX27Boolean = false;
					},
					SFX28false(){
						this.SFX28Boolean = false;
					},
				goToHelp(){
					var vm = this;

					this.SFXPlayer11.start();
					setTimeout(this.hideSectionPage, 100);
					setTimeout(this.hideDiscoPage, 100);
					setTimeout(function(){ vm.FutureFit = "" }, 600);
					setTimeout(function(){ vm.FutureFit = "Ha" }, 800);
					setTimeout(function(){ vm.FutureFit = "Ha ha" }, 1000);
					setTimeout(function(){ vm.FutureFit = "Ha ha ha" }, 1200);
					setTimeout(function(){ vm.FutureFit = "Ha ha ha ha" }, 1400);
					setTimeout(function(){ vm.FutureFit = "Ha ha ha" }, 1600);
					setTimeout(function(){ vm.FutureFit = "Ha ha" }, 1800);
					setTimeout(function(){ vm.FutureFit = "Ha" }, 2000);
					setTimeout(function(){ vm.FutureFit = "Ha ha" }, 2200);
					setTimeout(function(){ vm.FutureFit = "Ha ha ha" }, 2400);
					setTimeout(function(){ vm.FutureFit = "Ha ha ha ha" }, 2600);
					setTimeout(function(){ vm.FutureFit = "Ha ha ha" }, 2800);
					setTimeout(function(){ vm.FutureFit = "Ha ha" }, 3000);
					setTimeout(function(){ vm.FutureFit = "Ha" }, 3200);
					setTimeout(function(){ vm.FutureFit = "Ha ha" }, 3400);
					setTimeout(function(){ vm.FutureFit = "Ha ha ha" }, 3600);
					setTimeout(function(){ vm.FutureFit = "Ha ha ha ha" }, 3800);
					setTimeout(this.showDiscoPage, 600);
					setTimeout(this.showHelpPage, 3000);
				},	
				goToHome(){
					var vm = this;

					setTimeout(function(){ vm.FutureFit = "Halloween" }, 390);
					setTimeout(this.showSectionPage, 400);
					setTimeout(this.hideHelpPage, 100);
				},					
		}
	}
</script>
<style>

</style>





// WEBPACK FOOTER //
// template.vue?a1517052